import { BaseDialog, BaseDialogProps } from '../common/dialog/BaseDialog';
import * as React from 'react';
import { Grid2 as Grid, Chip } from '@mui/material';

interface Props extends BaseDialogProps {
    readonly segments: Entities.Segment[];
    readonly onSelectSegment: (id: string) => void;
}

export class SelectSegmentDialog extends BaseDialog<Props> {
    protected renderContent(): React.JSX.Element {
        const { segments, onSelectSegment } = this.props;
        const segmentElements: React.JSX.Element[] = [];
        segments.forEach(segment => {
            const selectSegment = () => {
                onSelectSegment(segment.id);
            };
            segmentElements.push(
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Chip
                        color={'secondary'}
                        label={`${segment.name}`}
                        style={{ width: '100%', backgroundColor: `${segment.color}`, color: 'white' }}
                        onClick={selectSegment}
                    />
                </Grid>
            );
        });

        return (
            <Grid container={true} direction="row" justifyContent="space-around" alignItems="center" spacing={2}>
                {segmentElements}
            </Grid>
        );
    }
}
